import { useContext, useEffect, useRef, useState } from "react";
import api from "../components/customAxios/Axios";
import CandidateResult from "../components/RespJdDash/candidateResult";
import MultipleFileUpload from "../components/RespJdDash/multipleFileUpload";
import GeneratedQuesPopup from "../components/RespJdDash/generatedQuesPopup";
import CandidateDetailsPopup from "../components/RespJdDash/candidateDetailsPopup";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import ConfirmButton from "../components/confirmationPopup";
import { useToast } from "../components/toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../context/JobContext";
import { setCandList } from "../context/JobContext";
import { ConfirmDialog } from "primereact/confirmdialog";
import { MdOutlineStickyNote2 } from "react-icons/md";

import { BsSend } from "react-icons/bs";
import { IoIosRefresh } from "react-icons/io";
import { useLoader } from "@/context/loaderContext";

import { FiSearch } from "react-icons/fi";
import { GoDotFill } from "react-icons/go";
import Pagination from "@/components/Pagination";
import ScoreJustificationModal from "@/components/RespJdDash/ScoreJustificationModal";
import useBreadCrumb from "@/context/BreadCrumbContext";
import useRelativeTime from "@/hooks/useRelativeTime";
import StatusCards from "@/components/RespJdDash/StatusCard";
import { useTimerContext } from "@/context/TimerContext";
// import ReactQuill from "react-quill";
interface MyObjectType {
	jd: string | null;
	role: string | null;
	job_id: number | null;
	created_by_name: string;
	user_id: string
}

interface DataItem {
	resume_id: string;
	candidate_name: string;
	JD_MATCH: string;
	MATCH_STATUS: string;
	Matching_Skills: string;
	Missing_Skills: string;
}

const RespJdDash = () => {
	const { setBreadCrumb } = useBreadCrumb();
	const { setLoading } = useLoader();
	const toast = useToast();
	const { id } = useParams();
	const navigate = useNavigate();
	const { state, dispatch } = useContext(UserContext)!;
	const [jobDetails, setJobDetails] = useState<MyObjectType | null>(null);
	const [Data, setData] = useState<DataItem[]>([]);
	const [candidateCount, setCandidateCount] = useState({
		shortlistedCount: 0,
		reviewCount: 0,
		rejectedCount: 0,
		screeningCount: 0
	})
	const intervalRef = useRef<NodeJS.Timeout | null>(null);
	const [isAssessmentGenerated, setIsAssessmentGenerated] = useState(false);
	const [assessementCutOff, setAssessementCutOff] = useState(null);

	const [show_Result, setshow_Result] = useState(false);
	const [showDetails, setShowDetails] = useState(false);
	const [approval, setApproval] = useState(false);
	const [resume_id, setResume_id] = useState("");
	const [nameQuery, setNameQuery] = useState("");
	const [sortOrder, setSortOrder] = useState("-updated_at");
	const [totalItems, setTotalItems] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [selectedStatus, setSelectedStatus] = useState("");
	const [scoreRange, setScoreRange] = useState({
		shortListedMinScore: 70,
		shortListedMaxScore: 100,
		ReviewMinScore: 59,
		ReviewMaxScore: 69,
		RejectedMinScore: 0,
		RejectedMaxScore: 58,
	})
	const [category, setCategory] = useState("shortlisted")
	const [allResumeProcessed, setAllResumeProcessed] = useState(true);
	const [callFunction, setCallFunction] = useState(false)
	const statusOptions = [
		"Assessment Sent",
		"Assessment Completed",
		"Assessment Terminated",
	];

	const handleSelect = (status: string) => {
		setSelectedStatus(status === "Clear" ? "" : status);
	};
	useEffect(() => {
		setBreadCrumb({
			mainLabel: {
				label: "Job",
				link: "joblist",
			},
			currentLabel: "Applicants",
		});
	}, []);

	const handlePageClick = (page: number) => {
		setCurrentPage(page);
	};
	useEffect(() => {
		setItemsPerPage(10);
	}, []);

	const getCandList = async () => {
		setLoading(true);
		try {
			const res = await api.get(`/get_resume_scores?job_id=${id}`, {
				params: {
					shortlisted_min_score: scoreRange.shortListedMinScore,
					shortlisted_max_score: scoreRange.shortListedMaxScore,
					review_min_score: scoreRange.ReviewMinScore,
					review_max_score: scoreRange.ReviewMaxScore,
					rejected_min_score: scoreRange.RejectedMinScore,
					rejected_max_score: scoreRange.RejectedMaxScore,
					sort_by: sortOrder,
					page: currentPage,
					search_value: nameQuery,
					filter_value: selectedStatus.split(" ")[1] === "Sent" ? "Send" : selectedStatus.split(" ")[1],
					per_page: itemsPerPage,
					category: category
				},
			});
			if (res.status === 200) {
				const candidateData = res.data.resume_scores;
				setAssessementCutOff(res.data.cut_off_score);
				setCandidateCount({
					shortlistedCount: res.data?.shortlisted_count || 0,
					reviewCount: res.data?.review_count || 0,
					rejectedCount: res.data?.rejected_count || 0,
					screeningCount: res.data?.screening_count || 0
				})
				setIsAssessmentGenerated(res.data.generate_questions_flag);
				setTotalPages(Math.ceil(res.data.total / itemsPerPage));
				setTotalItems(res.data.total);
				if (category === "screening") {

					const hasNonFailed = candidateData.some((item: any) => item.processing_status !== "failed");
					console.log(hasNonFailed)
					setAllResumeProcessed(hasNonFailed);
				}
				dispatch(setCandList(candidateData));

			}
		} catch (err: any) {
			setLoading(false);
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Error fetching candidate details",
				description: err.response?.data?.error || err.response?.data?.message || "An error occurred.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};
	const getCandListRef = useRef(getCandList);

	// Update the ref on every render to point to the latest function
	useEffect(() => {
		getCandListRef.current = getCandList
		getCandListRef.current()

	}, [selectedStatus, sortOrder, scoreRange, category, currentPage, itemsPerPage, callFunction]);

	useEffect(() => {
		setLoading(true);
		const getJobDetails = async () => {
			try {
				const response = await api.get(`/jobs/${id}`);
				setJobDetails({
					role: response.data.job_details.role,
					jd: response.data.job_details.jd,
					job_id: response.data.job_details.job_id,
					created_by_name: response.data.job_details.created_by_name,
					user_id: response.data.job_details.user_id
				});
				localStorage.setItem("job_id", response.data.job_details.job_id);
			} catch (err: any) {
				setLoading(false);
				toast.error({
					type: "background",
					duration: 3000,
					status: "Error",
					title: "Error fetching job details",
					description: err?.response?.data?.error || err.response?.data?.message || "An error occurred.",
					open: true,
				});
			} finally {
				setLoading(false);
			}
		};
		getJobDetails();
	}, []);

	useEffect(() => {
		setData(state.candidate_list);
	}, [state.candidate_list]);


	const deleteCandHandler = async (item: any) => {
		setLoading(true);
		try {
			const resp = await api.get(
				`/delete_resume?resume_id=${item.resume_id}&job_id=${jobDetails?.job_id}`
			);
			if (resp.status === 200) {
				setLoading(false);
				toast.success({
					type: "background",
					duration: 3000,
					status: "Success",
					title: "Candidate deleted successfully",
					description: "",
					open: true,
				});
				if (Data.length === 1 && currentPage > 1) {
					setCurrentPage((prev) => prev - 1);
					return;
				}
				await getCandList();
			}
		} catch (error: any) {
			setLoading(false);
			toast.error({
				type: "background",
				duration: 3000,
				status: "error",
				title: "Error Deleting Candidate",
				description: error.response?.data?.message || error.response?.data?.error,
				open: true,
			});
		}
	};

	// const showCandDetails = (resume_id: string) => {
	// 	setResume_id(resume_id);
	// 	setShowDetails(true);
	// };

	const closeDetails = () => {
		setShowDetails(false);
	};

	// const popHandle = (item: DataItem) => {
	// 	const itemString = JSON.stringify(item);
	// 	localStorage.setItem("item", itemString);
	// 	setResume_id(item.resume_id);
	// 	setApproval(true);
	// };

	const showResult = async (resume_id: string) => {
		setResume_id(resume_id);
		setshow_Result(!show_Result);
	};
	// useEffect(() => {
	// 	getCandList();
	// }, [selectedStatus, sortOrder, scoreRange, category, currentPage, itemsPerPage]);

	useEffect(() => {
		// Set a timeout for the search
		const handler = setTimeout(() => {
			setCurrentPage(1)
			getCandList();
		}, 2000);

		// Cleanup the timeout if searchQuery changes before 2 seconds
		return () => clearTimeout(handler);
	}, [nameQuery]);



	useEffect(() => {
		// Start the interval only if screeningCount > 0 and not already running
		if (candidateCount.screeningCount > 0 && allResumeProcessed && !intervalRef.current && category === "screening") {
			intervalRef.current = setInterval(() => {
				getCandListRef.current(); // use ref to call latest version
			}, 10000);
		}

		// Stop the interval when screeningCount becomes 0
		if ((candidateCount.screeningCount === 0 || !allResumeProcessed) && intervalRef.current) {
			clearInterval(intervalRef.current);
			intervalRef.current = null;
		}

		// Cleanup on unmount
		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
				intervalRef.current = null;
			}
		};
	}, [candidateCount.screeningCount]);

	type Range = { min: number; max: number } | null;
	const [selectedRanges, setSelectedRanges] = useState<{
		shortlisted: Range;
		review: Range;
		rejected: Range;

	}>({
		shortlisted: { min: 70, max: 100 },
		review: { min: 59, max: 69 },
		rejected: { min: 0, max: 58 },
	});
	const { formatTime, setTimeLeft, timeLeft } = useTimerContext()
	const getShortlistedRanges = () => [
		{ label: "100-90", min: 90, max: 100 },
		{ label: "100-80", min: 80, max: 100 },
		{ label: "100-70", min: 70, max: 100 },
		{ label: "100-60", min: 60, max: 100 },
	];

	const getReviewRanges = (shortlistedMin?: number) => {
		const upper = (shortlistedMin ?? selectedRanges.shortlisted?.min ?? 90) - 1;
		const base = [];
		for (let i = upper; i > 40; i -= 10) {
			const lower = i - 10 < 40 ? 40 : i - 10;
			base.push({
				label: `${upper}-${lower}`,
				min: lower,
				max: upper,
			});
		}
		return base;
	};

	const getRejectedRanges = (reviewMin?: number) => {
		const upper = (reviewMin ?? selectedRanges.review?.min ?? 50) - 1;
		const base = [];
		base.push({
			label: `${upper}-0`,
			min: 0,
			max: upper,
		});

		return base;
	};


	const handleSelect2 = (status: string, range: { min: number; max: number }) => {
		const updated = { ...selectedRanges, [status]: range };

		if (status === "shortlisted") {
			const newReviewRanges = getReviewRanges(range.min);
			const newReview = newReviewRanges.length ? newReviewRanges[0] : null;

			const newRejectedRanges = getRejectedRanges(newReview?.min ?? 50);
			const newRejected = newRejectedRanges.length ? newRejectedRanges[0] : null;

			updated.review = newReview;
			updated.rejected = newRejected;
		} else if (status === "review") {
			const newRejectedRanges = getRejectedRanges(range.min);
			updated.rejected = newRejectedRanges.length ? newRejectedRanges[0] : null;
		}

		setScoreRange({
			shortListedMinScore: updated.shortlisted?.min ?? 70,
			shortListedMaxScore: updated.shortlisted?.max ?? 100,
			ReviewMinScore: updated.review?.min ?? 59,
			ReviewMaxScore: updated.review?.max ?? 69,
			RejectedMinScore: updated.rejected?.min ?? 0,
			RejectedMaxScore: updated.rejected?.max ?? 58,
		})

		setSelectedRanges(updated);
	};
	useEffect(() => {
		setCurrentPage(1)
	}, [category])

	useEffect(() => {

		if (!candidateCount.screeningCount) return;
		setTimeLeft(candidateCount.screeningCount * 10)
	}, [candidateCount]);


	return (
		<div
			id="show-user-code"
			className=" dark:bg-zinc-800 text-zinc-900 dark:text-white"
		>
			{show_Result && (
				<CandidateResult
					resume_id={resume_id}
					jobId={id ?? ""}
					onClick={() => {
						setshow_Result(!show_Result);
					}}
				/>
			)}

			{/* <Header></Header> */}

			<div className="bg-white md:p-4  rounded-xl w-full min-h-[85vh]  ">
				<div className="mb-4 pr-2">
					<div className="flex items-center gap-x-1 mb-4">
						<button onClick={() => navigate("/joblist")}>
							<svg width="20" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M10.0154 0.733154L4.23065 6.51518C3.93728 6.79466 3.93728 7.23137 4.23065 7.51085L10.0155 13.2928"
									stroke="#7F7F7F"
									strokeMiterlimit="2.613"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</button>
						<Link to={`/job-details/${id}`} className="text-2xl font-bold hover:underline text-[#438437] cursor-pointer">{jobDetails?.role}</Link>
					</div>
					{localStorage.getItem("user") !== jobDetails?.user_id && <div className="flex items-center gap-2 mt-1">
						<span className="text-sm text-gray-500">Created By:-</span>
						<span className="text-sm font-medium text-gray-700">{jobDetails?.created_by_name}</span>
					</div>}
					{/* <div className="text-xl font-semibold border-b pb-3"></div> */}

					{/* 	<div className="text-xl font-semibold my-3">Job Description</div>
					<pre className="h-[8rem] md:text-base text-sm font-main whitespace-pre-wrap break-words overflow-y-auto border rounded-xl p-2 text-justify">
						{jobDetails?.jd}
					</pre> */}


					<div className="flex flex-row justify-between items-start md:items-center mt-4 mb-2 gap-2">
						<div className="md:text-xl text-lg font-semibold">Applicants for this Role</div>
						{candidateCount.screeningCount === 0 && (
							isAssessmentGenerated ? (
								<button
									onClick={() => navigate(`/respective-dashboard/view-assessment/${id}`)}
									className="text-sm text-[#438437] bg-[#BDE4C3] font-medium hover:scale-110 transition focus:outline-none md:p-2 p-1.5 rounded-md"
								>
									View Assessment
								</button>
							) : (
								<button
									onClick={() => navigate(`/respective-dashboard/generate-assessment/${id}`)}
									className="text-sm text-[#438437] bg-[#BDE4C3] font-medium hover:scale-110 transition focus:outline-none md:p-2 p-1.5 rounded-md"
								>
									Configure Assessment
								</button>
							)
						)}
					</div>

					{(candidateCount.rejectedCount || candidateCount.screeningCount || candidateCount.reviewCount || candidateCount.shortlistedCount) ?

						<StatusCards setScoreRange={setScoreRange} setCategory={setCategory} category={category} count={candidateCount} setCurrentPage={setCurrentPage} /> : <></>
					}



					<div className="flex flex-wrap justify-center md:justify-between gap-2 items-center mb-4 font-body bg-[#F9F9FA] p-2 rounded-xl">
						<div className="flex flex-wrap gap-3 items-center w-full md:w-auto">
							<div className="relative group ml-2">
								<MultipleFileUpload setCallFunction={setCallFunction} />

							</div>

							<div className="relative group ml-2">
								<DropdownMenu>
									<DropdownMenuTrigger asChild>
										<button className="relative flex items-center gap-2 p-2 rounded hover:bg-gray-100 transition">
											<svg width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M1 1H20" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
												<path d="M5 6H16" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
												<path d="M9 11H12" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
											</svg>
											{selectedStatus && (
												<span className="absolute top-0 right-0 -mt-1 -mr-1 bg-red-500 text-white text-xs font-bold rounded-full w-4 h-4 flex items-center justify-center">
													!
												</span>
											)}
										</button>
									</DropdownMenuTrigger>
									<DropdownMenuContent className="w-56 p-3">
										<DropdownMenuLabel>Status</DropdownMenuLabel>
										<DropdownMenuSeparator />
										{statusOptions.map((status) => (
											<DropdownMenuItem
												key={status}
												onClick={() => handleSelect(status)}
												className={`${selectedStatus === status ? "bg-gray-100 font-semibold" : ""} cursor-pointer`}
											>
												{status}
											</DropdownMenuItem>
										))}
										<DropdownMenuSeparator />
										<DropdownMenuItem className="cursor-pointer font-bold" onClick={() => handleSelect("Clear")}>
											Clear
										</DropdownMenuItem>
									</DropdownMenuContent>
								</DropdownMenu>
								<p className="absolute w-[60px] text-center ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
									Filter
								</p>
							</div>
							<div className="ml-2 relative group" onClick={() => setSortOrder((prev) => (prev === "-updated_at" ? "updated_at" : "-updated_at"))}>
								<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M14.3536 0.646447L10.4645 3.82843L11.1716 4.53553L14 1.70711L16.8284 4.53553L17.5355 3.82843L14.3536 0.646447Z" fill="black" />
									<path d="M13.5 1V15H14.5V1H13.5Z" fill="black" />
									<path d="M3.64645 15.3536L7.53553 12.1716L6.82843 11.4645L4 14.2929L1.17157 11.4645L0.464466 12.1716L3.64645 15.3536Z" fill="black" />
									<path d="M4.5 15V1H3.5V15H4.5Z" fill="black" />
								</svg>
								<p className="absolute w-[50px] text-center ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
									Sort
								</p>
							</div>


							<div className="ml-2 relative group">
								<button className="hover:scale-110 transition mt-2" onClick={getCandList}>
									<IoIosRefresh size={20} />
								</button>
								<p className="absolute w-[100px] text-center ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
									Refresh
								</p>
							</div>
						</div>

						<div className="md:flex flex-wrap gap-3 items-center">
							<div className="flex ">
								{(candidateCount.rejectedCount || candidateCount.screeningCount || candidateCount.reviewCount || candidateCount.shortlistedCount) ?
									<div>
										{/* Shortlisted Dropdown */}
										{category === "shortlisted" && (
											<div className="flex gap-2 items-center mt-2">
												<label>ATS Score Range:
												</label>
												<select
													className="mt-1 block border border-gray-300 rounded-md px-2 py-2 text-sm "

													onChange={(e) => {
														const [min, max] = e.target.value.split("-").map(Number);
														handleSelect2("shortlisted", { min, max });
													}}
													value={
														selectedRanges.shortlisted
															? `${selectedRanges.shortlisted.min}-${selectedRanges.shortlisted.max}`
															: ""
													}
												>
													<option value="" disabled>Select Range</option>
													{getShortlistedRanges().map((range, i) => (
														<option key={i} value={`${range.min}-${range.max}`}>{range.label}</option>
													))}
												</select>
											</div>
										)}

										{/* Review Dropdown */}
										{category === "review" && (
											<div className="flex gap-2 items-center mt-2">
												<label>ATS Score Range:
												</label>
												<select
													className="mt-1 block border border-gray-300 rounded-md px-2 py-1 text-sm "
													onChange={(e) => {
														const [min, max] = e.target.value.split("-").map(Number);
														handleSelect2("review", { min, max });
													}}
													value={
														selectedRanges.review
															? `${selectedRanges.review.min}-${selectedRanges.review.max}`
															: ""
													}
												>
													<option value="" disabled>Select Range</option>
													{getReviewRanges().map((range, i) => (
														<option key={i} value={`${range.min}-${range.max}`}>{range.label}</option>
													))}
												</select>
											</div>
										)}

										{/* Rejected Dropdown */}
										{category === "rejected" && (
											<div className="flex gap-2 items-center mt-2">
												<label>ATS Score Range:
												</label>
												<select
													className="mt-1 block border border-gray-300 rounded-md px-2 py-1 text-sm "
													onChange={(e) => {
														const [min, max] = e.target.value.split("-").map(Number);
														handleSelect2("rejected", { min, max });
													}}
													value={
														selectedRanges.rejected
															? `${selectedRanges.rejected.min}-${selectedRanges.rejected.max}`
															: ""
													}
												>
													<option value="" disabled>Select Range</option>
													{getRejectedRanges().map((range, i) => (
														<option key={i} value={`${range.min}-${range.max}`}>{range.label}</option>
													))}
												</select>
											</div>
										)}

										{/* Screening Section */}
										{
											category === "screening" && allResumeProcessed && <div className="mt-2.5 block">
												<label>Estimated Time: {formatTime(timeLeft)}</label>
											</div>
										}
									</div> : <></>}

							</div>
							<div className="w-full md:w-auto mt-2 md:mt-0">
								<div className="relative">
									<span className="absolute inset-y-0 left-2 flex items-center text-gray-500">
										<FiSearch size={"18"} />
									</span>
									<input
										type="text"
										value={nameQuery}
										onChange={(e) => setNameQuery(e.target.value)}
										placeholder="Search here..."
										className="w-full p-1.5 pl-8 border border-gray-300 rounded-lg"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="flex flex-wrap items-center gap-3 my-4  font-body">
					<div className="flex gap-1 md:gap-3 items-center flex-none justify-center">
						{/* Hidden File Input */}
						{/* <input
							required
							type="file"
							ref={fileInputRef}
							className="hidden"
							onChange={(e) =>
								setFile(e.target.files ? e.target.files[0] : null)
							}
						/> */}

						{/* Upload or Add Button */}
						{/* {file ? (
							<button
								className="bg-green-500 text-white w-full sm:w-32 h-10 p-2 rounded-md shadow-md transition-colors"
								onClick={addResume}
							>
								Upload
							</button>
						) : (
							<button
								className="bg-[#438437] text-white md:w-auto h-10 p-2 rounded-md shadow-md hover:bg-[#0b66bcb7] transition-colors"
								onClick={handleBrowseClick}
							>
								Add new Candidate
							</button>
						)} */}
					</div>
				</div>

				<div className="overflow-x-auto px-3">
					<div className="h-[55vh] min-w-[800px]  overflow-y-auto">
						{Data.length > 0 ? (
							<table className="w-full table-auto">
								<ConfirmDialog />
								<thead className="bg-white sticky top-0 text-gray-500">
									<tr>
										{localStorage.getItem("role") === "product-owner" && (
											<th className="py-2 px-2">User ID</th>
										)}
										<th className="py-2 px-2">Resume Upload</th>
										<th className="py-2 px-2">Name</th>
										<th className="py-2 px-2">ATS Score</th>
										<th className="py-2 px-2">Experience Match</th>
										<th className="py-2 px-2">Status</th>
										<th className="py-2 px-2">Assessment Score</th>
										<th className="py-2 px-2">Action</th>
									</tr>
								</thead>
								<tbody>
									{Data.map((item: any, index) => (
										<tr key={index} className="border-b dark:border-zinc-600 text-sm">
											{/* {localStorage.getItem("role") === "product-owner" && (
												<td className="px-2 py-1 truncate">{item.email.split("@")[0]}</td>
											)} */}
											<td className="px-2 py-1">{useRelativeTime(item.upload_date)}</td>
											<td

												className={`px-2 py-1 underline text-[#438437]  ${item.candidate_name !== "Fetching Details" ? "cursor-pointer" : "cursor-not-allowed"}`}
												onClick={() => {
													if (item.candidate_name !== "Fetching Details")
														navigate(`/respective-dashboard/candidate-resume/${id}/${item.candidate_id}`)

												}
												}
											>
												{item.processing_status === "failed" ? item.resume_filename : item.candidate_name}
											</td>
											<td className="px-2 py-1">
												<div className="flex items-center gap-2">
													{item.resume_skills_match.average_primary_score.toFixed(2)}
													{item.candidate_name !== "Fetching Details" && (
														<ScoreJustificationModal
															jobSkillSet={item.job_skillset}
															resumeSkill={item.resume_skills_match}
															overAllJustification={item.overall_ai_explanation}
														/>
													)}
												</div>
											</td>
											<td className="px-2 py-1">
												{item.candidate_name !== "Fetching Details" ? (
													<span
														className={`py-1 px-2 rounded-full ${item.experience_match === 1
															? "bg-[#BDE4C3] text-[#009617]"
															: "bg-[#F7C5C5] text-[#CA4F4F]"}`}
													>
														{item.experience_match === 1 ? "Match" : "Mismatch"}
													</span>
												) : (
													<span>...</span>
												)}
											</td>
											<td className="px-2 py-1">
												<div
													className={`flex items-center ${item.status?.includes("Assessment link send to candidate")
														? "text-[#8183D6]"
														: item.status?.includes("Assessment completed")
															? "text-[#2B9870]"
															: item.status?.includes("Terminated") || item.processing_status === "failed"
																? "text-red-500"
																: "text-[#FFC452]"}`}
												>
													<GoDotFill />
													<span className="ml-1">
														{item.candidate_name !== "Fetching Details"
															? item.status?.includes("Assessment link send to candidate")
																? "Assessment Link Sent to Candidate"
																: item.status?.includes("Assessment completed")
																	? "Assessment Completed"
																	: item.status?.includes("Terminated")
																		? "Assessment Terminated"
																		: "Assessment Not Sent"
															: item.processing_status === "failed" ? "Resume Screening Failed - Please Delete and Reupload" : "Screening Candidate"}
													</span>
												</div>
											</td>
											<td className="px-2 py-1 text-gray-600">
												<ul className="space-y-1 text-sm">
													<li className="text-[#438437]">
														<span className="font-semibold">Minimum Qualifying Score:</span> {assessementCutOff ?? "N/A"}
													</li>
													<li>
														<span className="font-semibold">Assessment Score:</span>{" "}
														<span className={item?.total_normalized_score > (assessementCutOff || 0) ? "text-green-500" : ""}>
															{item?.total_normalized_score ?? "N/A"}
														</span>
													</li>
													<li>
														{/* <span className="font-semibold">Proceed Next:</span>{" "}
														<span
															className={
																item?.recommendation === "Rejected" ? "text-red-600" : "text-[#009617]"
															}
														>
															{item?.recommendation === "Rejected"
																? "No"
																: item?.recommendation === "Accepted"
																	? "Yes"
																	: "N/A"}
														</span> */}
													</li>
												</ul>
											</td>
											<td className="px-2 py-1 relative">
												<div className="flex items-center gap-3">
													{item.candidate_name !== "Fetching Details" && (
														<>
															{item.assessment_status === 1 && item.status !== "Terminated" ? (
																<div className="relative group">
																	<button
																		className="hover:scale-110 transition"
																		onClick={() => showResult(item.resume_id)}
																	>
																		<MdOutlineStickyNote2 size={20} />
																	</button>
																	<p className="absolute w-[80px] text-center right-2 top-6 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
																		View Result
																	</p>
																</div>
															) : (
																isAssessmentGenerated &&
																item.assessment_status !== 1 && (
																	<div className="relative group">
																		<button
																			className="hover:scale-110 transition"
																			onClick={() =>
																				navigate(
																					`/respective-dashboard/send-assessment/${id}/${item.resume_id}`
																				)
																			}
																		>
																			<BsSend size={20} />
																		</button>
																		<p className="absolute w-[100px] text-center right-2 top-6 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
																			Send Assessment
																		</p>
																	</div>
																)
															)}


														</>
													)}
													<div className="relative group">
														<ConfirmButton
															label={
																""
															}
															message="Are you sure you want to delete this applicant data?"
															header="Delete Applicant"
															icon="pi pi-times"
															acceptClassName="p-button-danger"
															onConfirm={() => deleteCandHandler(item)}
														/>
														<p className="absolute w-[60px] text-center right-2 top-6 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
															Delete
														</p>
													</div>
												</div>
											</td>


										</tr>
									))}
								</tbody>
							</table>
						) : (
							<div className="h-[30vh] flex justify-center items-center md:text-3xl text-lg text-gray-400">
								No Candidate
							</div>
						)}
					</div>
				</div>

			</div>
			{Data.length > 0 && (
				<Pagination
					dataLength={Data.length}
					currentPage={currentPage}
					handlePageClick={handlePageClick}
					totalItems={totalItems}
					totalPages={totalPages}
				/>
			)}
			{approval && (
				<GeneratedQuesPopup
					resume_id={resume_id}
					onClose={() => setApproval(false)}
					jobId={jobDetails?.job_id ?? null}
				/>
			)}
			{/* 
			{showSelectCandidatePopup && (
				<div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
					<div className="relative bg-white dark:bg-zinc-700 rounded-lg shadow p-6 max-w-md w-full ">
						<h2 className="text-lg font-semibold mb-4">Select Candidate</h2>
						<p className="mb-4">
							Please select at least one candidate before proceeding.
						</p>
						<button
							className="bg-blue-500 text-white p-2 rounded-lg shadow"
							onClick={() => setShowSelectCandidatePopup(false)}
						>
							OK
						</button>
					</div>
				</div>
			)} */}

			{showDetails && (
				<CandidateDetailsPopup
					resume_id={resume_id}
					job_id={jobDetails?.job_id ?? null}
					setShowDetails={setShowDetails}
					closeDetails={closeDetails}
				/>
			)}
		</div>
	);
};

export default RespJdDash;
